// eslint-disable-next-line no-restricted-globals
interface IDummyObserver extends IntersectionObserver {}

type TFallback = <T extends Element = Element> (el: T) => void
// eslint-disable-next-line no-restricted-globals
type TObserver = IntersectionObserver | IDummyObserver

/**
 * Az IntersectionObserver fölött egy wrapper,
 * hogy ha nem támogatja az adott browser, akkor legyen fallback.
 * Info: {@link https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API}.
 * @param callback - Az observer callback.
 * @param options  - A observer beállításai.
 * @param fallback - A fallback függvény, ami a dummy observe lesz.
 */
export default function createObserver (
  callback: IntersectionObserverCallback,
  options: IntersectionObserverInit,
  fallback: TFallback
): TObserver {
  // Ha a böngésző támogatja, akkor normál módon példányosítjuk és adjuk vissza.
  if ('IntersectionObserver' in window) {
    // eslint-disable-next-line no-restricted-globals
    const observer = new IntersectionObserver(callback, options)

    return observer
  }

  // Ha viszont nincs browser támogatás, akkor egy dummy observert csinálunk.
  const dummyObserver: IDummyObserver = {
    // Az observe függvény hívásra egyből a fallback hívódik.
    observe: fallback,
    unobserve: (_target: Element) => {
      // noop
    },
    disconnect: () => {
      // noop
    },
    root: null,
    rootMargin: '',
    thresholds: [],
    takeRecords: () => {
      return []
    }
  }

  return dummyObserver
}
